import { Layout, Space }  from 'antd';
import { HeaderActions }  from './components/headerActions';
import { useNavigate }    from 'react-router-dom';
import HeaderMenu         from './components/headerMenu';
import logo               from '@/assets/image/unity_logo.png';

const { Header: AntHeader } = Layout;

export const Header = () => {
  const navigate = useNavigate();

  return (
    <AntHeader 
      className="header" 
      style={{ 
        display: 'flex', 
        alignItems: 'center',
        boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
        zIndex: 1000,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, flex: 1, minWidth: 0 }}>
        <img alt="logo" src={logo} onClick={() => navigate('/')} className="logo" />
      </div>

      <Space align="center" size="middle">
        <HeaderActions />
        <HeaderMenu />
      </Space>
    </AntHeader>
  );
}
